export default function denomination (number, decimals = 2) {
  return ((number || 0) / 100).toFixed(decimals)
}
